<template>
    <div>
        <div class="posts__section artworks-contest__section">
            <header class="artworks-contest__header">
                <picture>
                    <source media="(max-width: 570px)" :srcset="getBannerImage(570)">
                    <source media="(max-width: 1200px)" :srcset="getBannerImage(1200)">
                    <img :src="getBannerImage(1600)" alt="Header image">
                </picture>
                <!-- <img :src="getBannerImage" alt=""> -->
                <h1><strong>{{ helpers.getTranslation(translations, 'title') }}</strong></h1>
                <p>{{ helpers.getTranslation(translations, 'description') }}</p>
            </header>

            <div v-for="(category, key) in categories"
                    :key="key"
                    class="posts__section artworks-contest__section">

                <div class="artworks-contest__category-header">
                    <h2>{{ key+1 }} {{ category.title }}</h2>
                    <p>{{ category.description }}</p>
                </div>

                <div
                    v-for="(artwork, index) in category.artworks"
                    :key="index"
                    :class="{
                        'post__content--selected': artworkIsSelected(category.id, artwork.id),
                        'post__content--disabled': artworkIsNotSelected(category.id, artwork.id)
                        }"
                    class="post__content">

                    <h2 style="display: inline-flex;">
                        <span class="heading-icon">
                            <img style="height: 30px" v-if="artwork.icon" :src="'https://www.amsterdamlightfestival.com/storage/' + artwork.icon">
                            <img v-else src="/site/img/heading-icon.svg">
                        </span>
                        <span>
                            {{ artwork.title }}
                        </span>
                    </h2>

                    <button @click="selectArtwork(category.id, artwork.id)" type="button" class="no-slider">
                        <div class="post__content-thumbnail post__content-thumbnail--no-slider" :data-locale="helpers.getLocale()">
                            <div class="">
                                <img v-if="artwork.thumbnails[0] !== null" :src="'https://www.amsterdamlightfestival.com/storage/' + artwork.thumbnails[0]" alt="">
                                <img v-else src="/site/img/ALF-thumbnail-artist-landscape.jpg" alt="">
                            </div>
                        </div><!-- /.post__content-thumbnail -->
                    </button>

                    <div class="post__content-inner2">
                        <p v-if="artwork.artistName" :title="artwork.artistName">{{ artwork.artistName }}<br>
                            <span>{{ artwork.editionTitle }}</span>
                        </p>
                        <div class="post__content-action">
                            <a :href="artwork.url" target="_blank" type="button" class="post__content-btn artwork artwork-detail-button">
                                {{ helpers.getTranslation(translations, 'show-details') }}
                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14.3" ><path d="M14 7.2L6.9 0l-.6.6 6 6.1H0v.9h12.3l-6 6.1.6.6z"/></svg>
                            </a>
                            <button @click="selectArtwork(category.id, artwork.id)" type="button" style="padding: 0 7px 0 7px" class="post__content-btn artwork">
                                {{ helpers.getTranslation(translations, 'choose') }}
                            </button>
                        </div><!-- /.action-section -->
                    </div><!-- /.post__content-inner2 -->
                </div><!-- /.post__content -->
            </div>
        </div>

        <div class="artworks-contest__form-container">
            <!-- TODO: ENGLISH! -->
            <header v-bind:class="{ 'artworks-contest__form-header': success }">
                <h2 v-if="!success">{{ helpers.getTranslation(translations, 'selected') }}</h2>
                <p v-if="!success">{{ helpers.getTranslation(translations, 'details') }}</p>
                <h2 v-if="success" v-html="helpers.getTranslation(translations, 'success-heading')"></h2>
                <p v-if="success" v-html="helpers.getTranslation(translations, 'success-text')"></p>
            </header>

            <form v-if="!success" class="artworks-contest__form artworks-contest__form--done newsletter-action__content__step" @submit.prevent="submit">
                <div class="form-group">
                    <label for="newsletter-widget__firstName" class="text-input__label">{{ helpers.getTranslation(translations, 'firstname') }}</label>
                    <input v-model="fields.firstname" autocomplete="off" :disabled="isNotVotedForEveryCategory()" type="text" id="newsletter-widget__firstName"  :placeholder="helpers.getTranslation(translations, 'firstname')" class="form-control text-input__input">
                    <span v-if="errors && errors.firstname">{{ errors.firstname[0] }}</span>
                </div>
                <div class="form-group">
                    <label for="newsletter-widget__lastName" class="text-input__label">{{ helpers.getTranslation(translations, 'lastname') }}</label>
                    <input v-model="fields.lastname" autocomplete="off" :disabled="isNotVotedForEveryCategory()" type="text" id="newsletter-widget__lastName" :placeholder="helpers.getTranslation(translations, 'lastname')" class="form-control text-input__input">
                    <span v-if="errors && errors.lastname">{{ errors.lastname[0] }}</span>
                </div>
                <div class="form-group">
                    <label for="newsletter-widget__email" class="text-input__label">{{ helpers.getTranslation(translations, 'email') }}</label>
                    <input v-model="fields.email" autocomplete="off" :disabled="isNotVotedForEveryCategory()" type="email" id="newsletter-widget__email" :placeholder="helpers.getTranslation(translations, 'email')"  class="form-control text-input__input">
                    <span v-if="errors && errors.email">{{ errors.email[0] }}</span>
                </div>
                <div class="form-group">
                    <label for="newsletter-widget__zip" class="text-input__label">{{ helpers.getTranslation(translations, 'zipcode') }}</label>
                    <input v-model="fields.zipcode" autocomplete="off" :disabled="isNotVotedForEveryCategory()" type="text" id="newsletter-widget__zip" :placeholder="helpers.getTranslation(translations, 'zipcode')" class="form-control text-input__input">
                    <span v-if="errors && errors.zipcode">{{ errors.zipcode[0] }}</span>
                </div>
                <button :disabled="isNotVotedForEveryCategory()" class="btn btn-primary" style="margin-top: 0;">
                    {{ helpers.getTranslation(translations, 'submit') }}
                    <span class="icon-arrow"><img src="/images/arrow_2.svg" alt=""></span> <div class="lds-ring"><div></div> <div></div> <div></div> <div></div></div>
                </button>
                <!-- TODO: REPLACE ALL form-group AND button INSIDE artworks-contest__form WITH THE DIV BELOW WHEN A FORM HAS BEEN SUBMITTED. REPLACE TEXT WITH NL/EN PROPER INPUT. -->
            </form>
        </div>
    </div>
</template>

<script>

/*
 * Import child components
 */
import helpers from './../../helpers'
import axios from 'axios'

axios.defaults.headers['Content-Type'] = 'application/json';
axios.defaults.headers['Accept'] = 'application/json';

export default {
    props: {
        'categories': { required: true },
        'translations': { required: true },
    },
    data: function() {
        return {
            votes: {},
            fields: {
                locale: helpers.getLocale()
            },
            errors: {},
            success: false,
            helpers: helpers
        }
    },

    methods: {
         getBannerImage: function(dimensionTest){
            return '/images/alf-header-artwork-contest-' + dimensionTest + '-' + this.helpers.getLocale()  + '.png';
        },

        selectArtwork: function(categoryId, artworkId){
            if(this.votes[categoryId] == artworkId){
                return  Vue.set(this.votes, categoryId, null)
            }

            Vue.set(this.votes, categoryId, artworkId)
        },

        getCategoriesCount: function () {
            return  Object.keys(this.categories).length
        },

        isNotVotedForEveryCategory: function () {
           return Object.keys(this.votes).length !== Object.keys(this.categories).length
        },

        artworkIsSelected: function(categoryId, artworkId){
            return this.votes[categoryId] == artworkId;
        },

        artworkIsNotSelected: function(categoryId, artworkId){
            return this.votes[categoryId] && this.votes[categoryId] != artworkId;
        },

        submit: function () {
            this.fields.votes = this.votes;
            axios.post('/artwork-contest/submit', this.fields).then(response => {
                this.fields = {};
                this.success = true;
            }).catch(error => {
                if (error.response.status === 422) {
                    this.errors = error.response.data.errors || {};
                }
            });
        }
    }
}
</script>

<style lang="scss" scoped>
    .filter__btn{
        border: none;
        max-width: 288px;
        margin-left: -10px;

        button{
            padding: 0 10px;
            border: 2px solid #000000;
            background: none;
            font-size: 14px;

            svg{
                margin-bottom: 4px;
            }
        }
    }

    .filter-btn{
        width: 100%;
    }

</style>



// WEBPACK FOOTER //
// resources/assets/js/site/components/artworks-contest/artworks-contest-root.vue